var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.983 20.5882C10.983 19.4736 11.8862 18.5706 13.0002 18.5706C14.1141 18.5706 15.017 19.4736 15.017 20.5882C15.017 21.7014 14.1141 22.6052 13.0002 22.6052C11.8862 22.6052 10.983 21.7014 10.983 20.5882ZM11.4874 8.48558C11.4874 7.65069 12.1647 6.97252 13.0002 6.97252C13.8353 6.97252 14.5129 7.65069 14.5129 8.48558V14.5364C14.5129 15.373 13.8353 16.0498 13.0002 16.0498C12.1647 16.0498 11.4874 15.373 11.4874 14.5364V8.48558ZM25.7879 21.6587L25.7008 21.5139C25.6922 21.4995 25.6844 21.4848 25.6755 21.4705L14.6107 2.56748C14.2894 2.00873 13.6935 1.625 13.0002 1.625C12.2222 1.625 11.5592 2.10341 11.2822 2.78086L0.398446 21.3812C0.152452 21.696 0 22.0877 0 22.5177C0 23.5444 0.831523 24.375 1.85763 24.375H24.1424C25.1678 24.375 26 23.5444 26 22.5177C26 22.2071 25.9161 21.9191 25.7819 21.662L25.7879 21.6587Z",
    fill: "#FBAB18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.610d5ae0786d52282a75810ff765fc3b.svg";
export { ForwardRef as ReactComponent };